<template>
  <div
    class="relative z-0 flex-1 focus:outline-none"
    :class="{ 'overflow-y-auto': !getPageScrollFlag }"
  >
    <div class="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
      <BaseGuide
        v-if="!hideGuide"
        class="group fixed right-4 bottom-2 hidden md:block"
      />
      <BaseBreadcrumb v-if="crumbs.length" />
      <RouterView />
    </div>
  </div>
</template>

<script lang="ts" setup>
import BaseBreadcrumb from "@/components/control/base-breadcrumb.vue";
import BaseGuide from "@/components/control/base-guide.vue";
import { computed, ComputedRef, ref } from "vue";
import { useRoute } from "vue-router";
import { useExtraStore } from "@/pinia/useExtraStore";
import { storeToRefs } from "pinia";

const hideGuide = ref(false);
const route = useRoute();
const extraStore = useExtraStore();
const { getPageScrollFlag } = storeToRefs(extraStore);
const crumbs: ComputedRef = computed(() => route.meta.breadCrumbs ?? []);
</script>
